import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectLoggedIn } from "../store/userSlice/userSelectors";
import { getLocalStorageController, REDIRECT_KEY } from "../helpers/localStorage";
import ConditionalRoute from "./ConditionalRoute";
import { PAGES_ENUM } from "../pages";
import { createURLPath } from "../helpers/urlBuilder";
import { Navigate } from "react-router-dom";

const storage = getLocalStorageController(REDIRECT_KEY)

export function saveNextWPPage(page) {
  storage.setItem(page);
}

export function loadNextWPPage() {
  return storage.getItem();
}

export function removeWPPage() {
  storage.removeItem();
}

const RouteToRegister = ({ children }) => {
  const isLoggedIn = useSelector(selectLoggedIn);
  const currentPage = window.location.pathname + window.location.search + window.location.hash;
  const encoded = encodeURIComponent(currentPage);

  useEffect(() => {
    if (!isLoggedIn) {
      saveNextWPPage(encoded);
    }
  }, [isLoggedIn, encoded]);

  return isLoggedIn ? children : <Navigate to={PAGES_ENUM.REGISTER_PAGE.path} />
}

export default RouteToRegister;